import { Button, Fade, Grid, Paper, Tooltip, Typography, withStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { Alert, CleanButton, Label, Loader, PrimaryButton, SelectField } from '../default'
import { PAYMENT_GATEWAY_CONSTS } from '../../class/constants'
import { acGeneratePayment } from '../../class/actions'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Check } from '@material-ui/icons'
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField'

const FormPayment = ({ classes, children, chargeData, currentCustomer, actionOverride, actionStyleOverride, actionText, loading, fetchError, charge, overrideAmount, cancel }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [amount, setAmount] = useState(1.99)
  const [paymentMethod, setPaymentMethod] = useState('UNDEFINED')
  const [amountError, setAmountError] = useState(null)
  const [error, setError] = useState(null)
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (chargeData) {
      setAmount(chargeData.amount)
      setPaymentMethod(chargeData.paymentMethod)
    }
  }, [chargeData])

  const validateAmount = value => {
    if (isNaN(value)) {
      setAmount(value)
      setAmountError(t('default.invalidValue'))
      return
    }

    if (amount < 1.99) {
      setAmount(value)
      setAmountError(t('forms.financial.valueTooLow'))
      return
    }

    setAmountError(null)
    setAmount(parseFloat(value))
  }

  useEffect(() => {
    if (overrideAmount) {
      setAmount(overrideAmount)
    }
  }, [overrideAmount])

  const generatePayment = () => {
    if (amountError) {
      return
    }

    setError(null)
    dispatch(acGeneratePayment(currentCustomer.id, amount, paymentMethod)).then(() => {
      setError(null)
    })
      .catch(err => {
        setError(`Aconteceu um erro!`)
      })
  }

  const invokeActionOverride = () => {
    actionOverride({
      amount, paymentMethod,
    })
  }

  return (
    <Grid container spacing={2} className={classes.grid}>
      <Grid item xs={8}>
        <CurrencyTextField
          variant='filled'
          currencySymbol="R$"
          outputFormat="number"
          decimalCharacter=","
          digitGroupSeparator="."
          label={t('forms.financial.amount')}
          value={amount}
          onChange={(e, v) => validateAmount(v)}
          error={amountError ? true : false}
          helperText={amountError ? amountError : null}
          style={{ width: '100%' }} />
      </Grid>
      <Grid item xs={8}>
        <SelectField
          label={t('forms.financial.paymentMethod')}
          id='financial-payment-select'
          value={paymentMethod}
          onChange={(e) => setPaymentMethod(e.target.value)}
          items={PAYMENT_GATEWAY_CONSTS.PAYMENT_METHODS}
          style={{ width: '100%' }} />
      </Grid>
      {
        children && children.map((child, index) => (
          <Grid item xs={8} key={index}>
            {child}
          </Grid>
        ))
      }
      <Grid item xs={12} style={actionStyleOverride ? { ...actionStyleOverride, display: 'flex', justifyContent: 'flex-end' } : { display: 'flex', justifyContent: 'flex-end'}}>
        <CleanButton onClick={cancel} style={{ marginRight: '15px' }}>
          {t('default.cancel')}
        </CleanButton>
        {
          loading ? <Loader /> : (
            <PrimaryButton onClick={actionOverride ? invokeActionOverride : generatePayment}>
              {
                <div>
                  {actionText ? actionText : t('modals.financial.confirm')}
                </div>
              }
            </PrimaryButton>
          )
        }
      </Grid>
      {
        (charge && charge.url) &&
        <Grid item xs={12}>
          <Label style={{ marginTop: '15px', marginBottom: '5px' }}>
            {t('forms.financial.chargeURL')}
          </Label>
          <Tooltip
            className={classes.urlLabel}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 500 }}
            title={
              <Typography>
                {t('modals.financial.copyToClipboard')}
              </Typography>
            }
            placement='top-end'
            arrow >
            <CopyToClipboard text={charge.url} onCopy={() => setCopied(true)}>
              <Paper>
                <Button style={{ textTransform: 'none', width: '100%' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={11} className={classes.urlLabel}>
                      <Label>
                        {charge.url}
                      </Label>
                    </Grid>
                    {
                      copied &&
                      <Grid item xs={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Check style={{ color: 'lightgreen' }} />
                      </Grid>
                    }
                  </Grid>
                </Button>
              </Paper>
            </CopyToClipboard>
          </Tooltip>
        </Grid>
      }
      {
        (fetchError) ? (
          <Grid item xs={12}>
            <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={fetchError.description ? fetchError.description : t('forms.financial.Error')} />
          </Grid>
        ) : error ? (
          <Grid item xs={12}>
            <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={error} />
          </Grid>
        ) : null
      }
    </Grid>
  )
}

const styles = theme => ({
  grid: {
    display: 'flex',
    flex: 1
  },
  urlLabel: {
    padding: theme.spacing(1),
    overflowWrap: 'break-word',
    cursor: 'pointer'
  }
})

const mapStateToProps = ({ ReducerFinancial }) => ({
  chargeData: ReducerFinancial.chargeCreation,
  loading: ReducerFinancial.loading,
  fetchError: ReducerFinancial.error,
  charge: ReducerFinancial.charge
})

export default connect(mapStateToProps)(withStyles(styles)(FormPayment))